import React, { Component } from 'react';

class ActivationStepDetails extends Component {
    render() {
        return (
            <div className="detail-step-holder">
              <h5 className="details-header">To activate your account, Please update the details</h5>
              <div className="step-dots">
                <div className="dot-holder active">
                  <span className="dot">1</span>
                  <h5 className="dot-name">VERIFICATION</h5>
                </div>
                <div className={this.props.isGarageProfileCompleted ? "dot-holder active" : "dot-holder"}>
                  <span className="dot">2</span>
                  <h5 className="dot-name">PROFILE DETAILS</h5>
                </div>
                <div className={this.props.isGarageServiceSelected ? "dot-holder active" : "dot-holder" }>
                  <span className="dot">3</span>
                  <h5 className="dot-name">SERVICE DETAILS</h5>
                </div>
              </div>
            </div>
        );
    }
}

export default ActivationStepDetails;



// WEBPACK FOOTER //
// ./src/components/common/ActivationStepDetails.jsx